module.exports = __webpack_public_path__ + "img/dwdoc.05107328.webp";